import { Component, Host, h } from '@stencil/core';

@Component({
  tag: 'cr-chart-wrapper-md',
  styleUrl: 'cr-chart-wrapper-md.css',
  shadow: true,
})
export class CrChartWrapperMd {

  render() {
    return (
      <Host>
        <bx-tile><slot /></bx-tile>
      </Host>
    );
  }

}
